import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onBeforeUnmount, watch } from "vue";
import { useRoute } from "vue-router/composables";
import throttle from "lodash/throttle";
import type Vue from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'WarningLayout',
  setup(__props) {

const route = useRoute();

const activeIndex = ref("WarningIndex");
const isFade = ref(false);
const fixedHeader = ref(false);
const warningMain = ref<Vue | null>(null);

watch(
  () => route.name,
  (name) => {
    if (name && activeIndex.value !== name) {
      activeIndex.value = name;
    }
  },
  { immediate: true }
);

const showHeaderFixedByScroll = throttle(() => {
  const main = warningMain.value?.$el as Element | undefined;
  if (!main) return;
  const rect = main.getBoundingClientRect();
  fixedHeader.value = rect.top < 0;
}, 300);

onMounted(() => {
  window.addEventListener("scroll", showHeaderFixedByScroll);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", showHeaderFixedByScroll);
});

function handleSelect(key: any) {
  activeIndex.value = key;
}

function onBeforeEnter() {
  document.querySelector("html")?.scrollTo(0, 0);
  isFade.value = true;
}

function onAfterEnter() {
  isFade.value = false;
}

return { __sfc: true,route, activeIndex, isFade, fixedHeader, warningMain, showHeaderFixedByScroll, handleSelect, onBeforeEnter, onAfterEnter }
}

})